import type { Schemas } from '#shopware'
import { useOrderDetails as swUseOrderDetails, useShopwareContext } from '@shopware/composables'

export function useOrderDetails(orderId: string, associations?: Schemas['Criteria']['associations']) {
    const { getDocumentFile: _swGetDocumentFile, ...coreUseOrderDetails } = swUseOrderDetails(orderId, associations)
    const { apiClient } = useShopwareContext()

    /**
     * Override: upstream getDocumentFile omits the `accept: 'application/pdf'` header,
     * so the response isn't returned as a binary Blob and the document download fails.
     */
    async function getDocumentFile(documentId: string, deepLinkCode: string): Promise<Blob> {
        const response = await apiClient.invoke(
            'download post /document/download/{documentId}/{deepLinkCode}',
            {
                // `accept` here is only a TS hint for the response type; the actual HTTP
                // Accept header must be set via `headers` (api-client merges only those).
                accept: 'application/pdf',
                headers: { accept: 'application/pdf' },
                pathParams: { documentId, deepLinkCode },
            },
        )
        return response.data
    }

    return {
        ...coreUseOrderDetails,
        getDocumentFile,
    }
}
